import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '../api/dashboard.api'

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: () => dashboardApi.fetchStats().then((r) => r.data.data),
    staleTime: 60_000,
  })
}
